import validationMessages from 'vee-validate/dist/locale/pl';
//citrix.com.pl
export default {
    privacyLinkLabel: "Polityką prywatności",
    privacyLink: '/pl-pl/about/legal/privacy/',
    privacyText: "Citrix będzie przetwarzać Twoje dane zgodnie z naszą ",
    privacyText2: "",
    resetText: "Jeżeli dane podane w formularzu nie są Twoje,",
    resetText2: "aby go wyczyścić.",
    resetLinkText: "kliknij tutaj",
    yes: "Tak",
    no: "Nie",
    submitBtn: {
        "Submit" : "Wyślij",
        "Get the eBook" : "Pobierz e-book",
        "Request a demo": "Poproś o prezentację",
        "Request a call": "Poproś o telefon"
    },
    apjPrivacy:{
        title: "Sposób, w jaki wykorzystujemy Twoje dane osobowe",
        company: "Citrix Systems Firma Citrix Systems Japan K.K.",
        part1: "(\"Citrix\") będzie wykorzystywać i przechowywać dane osobowe zgodnie z obowiązującym prawem i przepisami o ochronie danych osobowych oraz",
        linkText: "Polityką prywatności firmy Citrix",
        part2: "oraz tylko w przypadkach, gdy dostęp jest ściśle ograniczony. Firma Citrix będzie wykorzystywać dane osobowe wyłącznie zgodnie z postanowieniami Polityki prywatności. Dane nie będą wykorzystywane do innych celów. Zgodnie z Polityką prywatności firma Citrix może powierzyć przetwarzanie danych osobowych krajowym lub zagranicznym podmiotom, udostępniać dane osobowe oddziałom lub spółkom zależnym firmy Citrix na całym świecie, lub wysyłać dane osobowe do krajowych lub zagranicznych osób trzecich. Przekazując swoje dane osobowe firmie Citrix, użytkownik wyraża zgodę na gromadzenie i przetwarzanie danych osobowych zgodnie z opisem w Polityce prywatności firmy Citrix.",
        privacyAccept: "Oświadczam zapoznanie się z powyższymi postanowieniami i treścią Polityki prywatności firmy Citrix i wyrażam na nie zgodę."
    },
    fields: {
        "AnnualSales": {
            label: "Annual Sales"
        },
        "Company_Self_Reported__c": {
            label: "Firma"
        },
        "department": {
            label: "Dział",
            options: [
                { value: "Application Management", text: "Zarządzanie aplikacjami" },
                { value: "Consulting Services", text: "Usługi doradztwa" },
                { value: "Education / Training", text: "Edukacja/szkolenia" },
                { value: "Engineering", text: "Inżynieria" },
                { value: "Executive Office / Administration", text: "Biuro zarządu/administracja" },
                { value: "Finance / Accounting", text: "Finanse/księgowość" },
                { value: "Human Resources", text: "Zasoby ludzkie" },
                { value: "Information Technology - Systems", text: "Systemy IT" },
                { value: "Legal", text: "Prawo" },
                { value: "Marketing / PR", text: "Marketing/PR" },
                { value: "Networking", text: "Networking" },
                { value: "Operations / Manufacturing", text: "Operacje/produkcja" },
                { value: "Pre-Sales / Technical Support", text: "Przedsprzedaż/wsparcie techniczne" },
                { value: "Project Management", text: "Zarządzanie projektami" },
                { value: "Purchasing", text: "Zakupy" },
                { value: "Sales / Bus-Corp Development", text: "Sprzedaż/rozwój biznesu i korporacji" },
                { value: "Security", text: "Bezpieczeństwo" },
                { value: "Web / Online / E-Business", text: "Sieć/Internet/e-business" }
            ]
        },
        "Industry_Self_Reported__c": {
            label: "Przemysł",
            options: [
                { value: "Agriculture", text: "Rolnictwo" },
                { value: "Art & Membership", text: "Sztuka" },
                { value: "Conglomerate", text: "Konglomerat" },
                { value: "Construction and Design", text: "Projektowanie i budownictwo" },
                { value: "Business Consulting", text: "Doradztwo biznesowe" },
                { value: "E-Commerce", text: "E-commerce" },
                { value: "Education", text: "Edukacja" },
                { value: "Engineering", text: "Inżynieria" },
                { value: "Entertainment", text: "Rozrywka" },
                { value: "Chemical Manufacturing", text: "Przemysł chemiczny" },
                { value: "Pharmaceuticals", text: "Przemysł farmaceutyczny" },
                { value: "Charitable/Non-Profit", text: "Organizacja charytatywna/non-profit" },
                { value: "Finance", text: "Finanse" },
                { value: "Government/State-Province", text: "Rząd/władze wojewódzkie" },
                { value: "Government/Local", text: "Rząd/władze lokalne" },
                { value: "Government/National-Federal", text: "Rząd/władze państwowe" },
                { value: "Hospitality", text: "Gratyfikacje" },
                { value: "Real Estate", text: "Nieruchomości" },
                { value: "Legal", text: "Prawo" },
                { value: "Manufacturing", text: "Produkcja" },
                { value: "Mining - All", text: "Górnictwo – ogólnie" },
                { value: "Oil and Gas", text: "Ropa i gaz" },
                { value: "Consumer Packaged Goods", text: "Towary pakowane" },
                { value: "Publishing/Printing", text: "Działalność wydawnicza/drukarska" },
                { value: "Health Care", text: "Służba zdrowia" },
                { value: "Insurance", text: "Ubezpieczenia" },
                { value: "Service Provider", text: "Świadczenie usług" },
                { value: "Business/Personal Services", text: "Usługi biznesowe/personalne" },
                { value: "Personnel Services", text: "Usługi specjalistyczne" },
                { value: "Household Services", text: "Usługi domowe" },
                { value: "Professional Services", text: "Serviços profissionais" },
                { value: "Utilities", text: "Media" },
                { value: "Technology", text: "Technology" },
                { value: "Telecommunication", text: "Telekomunikacja" },
                { value: "Transportation", text: "Transport" },
                { value: "Retail/Wholesale", text: "Sprzedaż hurtowa/detaliczna" }
            ]
        },
        "NumberOfEmployees_Self_Reported__c" : {
            label: "Wielkość firmy",
            options: [
                { value: "50", text: "1-50" },
                { value: "500", text: "51-500" },
                { value: "749", text: "501-749" },
                { value: "4999", text: "750-4,999" },
                { value: "19999", text: "5,000-19,999" },
                { value: "20000", text: "20,000+" }
            ]
        },
        "NumberofEmployees__here___atlocation": {
            label: "Wielkość firmy",
            options: [
                { value: "", text: "" },
                { value: "1 to 250", text: "1 do 250" },
                { value: "251 to 500", text: "od 251 do 500" },
                { value: "501 to 1,000", text: "od 501 do 1 000" },
                { value: "1,001 to 5,000", text: "od 1 001 do 5 000" },
                { value: "5,001 +", text: "5 001 +" }
            ]
        },
        "Address2": {
            label: "Wiersz adresu 2"
        },
        "Address3": {
            label: "Wiersz adresu 3"
        },
        "city": {
            label: "Miejscowość"
        },
        "country": {
            label: "Kraj"
        },
        "email": {
            label: "Służbowy adres email"
        },
        "firstName": {
            label: "Imię"
        },
        "lastName": {
            label: "Nazwisko"
        },
        "phone": {
            label: "Numer telefonu"
        },
        "mobilePhone": {
            label: "Mobile Phone"
        },
        "postalCode": {
            label: "Kod pocztowy"
        },
        "salutation": {
            label: "Tytuł",
            options: [
                { value: "", text: ""},
                { value: "Dr.", text: "Dr."},
                { value: "Egr. Sig.", text: "Egr. Sig."},
                { value: "Frau", text: "Frau"},
                { value: "Gent.ma Sig.ra", text: "Gent.ma Sig.ra"},
                { value: "Herr", text: "Herr"},
                { value: "Madame", text: "Madame"},
                { value: "Mademoiselle", text: "Mademoiselle"},
                { value: "Miss", text: "Panna"},
                { value: "Monsieur", text: "Monsieur"},
                { value: "Mr.", text: "Pan"},
                { value: "Mrs.", text: "Pani"},
                { value: "Ms.", text: "Pani"},
                { value: "Professor", text: "Profesor"},
                { value: "Señor", text: "Señor"},
                { value: "Señora", text: "Señora"}
            ]
        },
        "state": {
            label: "Stan/prowincja"
        },
        "address": {
            label: "Adres:"
        },
        "Job_Title__c": {
            label: "Nazwa stanowiska",
            options: [
                { value: "System Administrator", text: "Administrator systemu" },
                { value: "Network Administrator / Engineer", text: "Administrator sieci/inżynier" },
                { value: "Analyst", text: "Analityk" },
                { value: "Architect", text: "Architekt" },
                { value: "Assistant", text: "Asystent" },
                { value: "Business Manager", text: "Business Manager" },
                { value: "Consultant", text: "Konsultant" },
                { value: "Developer / Programmer", text: "Programista" },
                { value: "Director", text: "Dyrektor" },
                { value: "Student", text: "Student" },
                { value: "IT Manager", text: "Kierownik ds. IT" },
                { value: "C-Level / President / VP", text: "Prezes/wiceprezes" },
                { value: "Owner / Partner", text: "Właściciel/partner" }
            ]
        },
        "Project_Budget__c": {
            label: "Planowany budżet",
            options: [
                { value: "Yes", text: "Tak" },
                { value: "No", text: "Nie" },
                { value: "Unknown", text: "Nie wiadomo" }
            ]
        },
        "Primary_Product_Interest__c": {
            label: "CTRL aby wybrać więcej niż jeden wybór (maksymalnie 5 wyborów)"
        },
        "Purchase_Timeframe__c": {
            label: "Ramy czasowe zakupu",
            options: [
                { value: "3 months or less", text: "3 miesiące lub mniej" },
                { value: "4 to 6 months", text: "od 4 do 6 miesięcy" },
                { value: "7 months or more", text: "7 miesięcy lub więcej" },
                { value: "No time frame", text: "Brak ram czasowych" },
                { value: "Unknown", text: "Niepewne" }
            ]
        },
        "Email_Blast_OK__c": {
            label: "Czy możemy przesyłać Ci wiadomości e-mail?",
            options: [
                { value: "Yes", text: "Tak" },
                { value: "No", text: "Nie" }
            ]
        },
        "Direct_Mail_OK__c": {
            label: "May we contact you by mail?",
            options: [
                { value: "Yes", text: "Tak" },
                { value: "No", text: "Nie" }
            ]
        },
        "OK_to_Call__c": {
            label: "Czy możemy do Ciebie dzwonić?",
            options: [
                { value: "Yes", text: "Tak" },
                { value: "No", text: "Nie" }
            ]
        },
        "Preferred_Language__c": {
            label: "Preffered language"
        },
        "Sales_Contact_Requested__c": {
            label: "Proszę, aby skontaktował się ze mną pracownik działu sprzedaży"
        },
        "NumberofDesktops": {
            label: "Number of Desktops"
        },
        "NumberofServersGlobal": {
            label: "Number of servers globally",
            options: [
                { value: "1 SERVER", text: "1 Server" },
                { value: "2-5 SERVERS", text: "2-5 Servers" },
                { value: "6-10 SERVERS", text: "6-10 Servers" },
                { value: "11-50 SERVERS", text: "11-50 Servers" },
                { value: "51-100 SERVERS", text: "51-100 Servers" },
                { value: "> 100 SERVERS", text: "> 100 Servers" }
            ]
        },
        "NumberofServersProject": {
            label: "Iloma serwerami zarządzasz?",
            options: [
                { value: "1 SERVER", text: "1 SERWER" },
                { value: "2-5 SERVERS", text: "OD2 DO 5 SERWERÓW" },
                { value: "6-10 SERVERS", text: "OD6 DO 10 SERWERÓW" },
                { value: "11-50 SERVERS", text: "OD11 DO 50 SERWERÓW" },
                { value: "51-100 SERVERS", text: "OD51 DO 100 SERWERÓW" },
                { value: "> 100 SERVERS", text: "> 100 SERWERY/SERWERÓW" }
            ]
        },
        "Comments_6__c":{
            label: "Uwagi"
        }
    },
    validation: validationMessages
}